import { render, staticRenderFns } from "./EditClientPricelist.vue?vue&type=template&id=1f8e4adb&"
import script from "./EditClientPricelist.vue?vue&type=script&lang=js&"
export * from "./EditClientPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports